
import KioskError from './KioskErrorModal'
import Modal from "@/components/Modal.vue";
import { Device as DeviceService, Customer } from "@/services/SOLO";
import { Select, Option } from "element-ui";
import { ValidationObserver, configure, extend, validate } from "vee-validate";
import { Facility,  DeviceSettings } from "@/models";
import {
  Component,
  ProvideReactive,
  Vue,
  Prop,
  Watch,
  Emit,
} from "vue-property-decorator";
import { translations, notificationAlerts, eventHandler } from "@/mixins";
import Multiselect from 'vue-multiselect';
import KioskErrorModal from './KioskErrorModal.vue';



@Component({
  components: {
    LoadingPanel: () => import("@/components/LoadingPanel.vue"),
    [Select.name]: Select,
    [Option.name]: Option,
    Multiselect,
    },
    mixins: [eventHandler, translations, notificationAlerts],
})
export default class FacilitiesFormModal extends Vue {
  open: boolean = false;
  parent: any;
  searchText: any = ''
  searchLocation: any = ''
  saving: boolean = false;
  $notify: any;
  customerMeta: any = {}
  loading: any = false
  searching: any = false
  $refs!: {
    formValidator: any;
  };
  model: DeviceSettings = {
    id: "",
    label: "",
    status: "",
    available: false,
    "location-id": "",
    "customer-id": "",
    "payment-gateway": "",
    uuid: "",
    "is-settings-password-protected": false,
    "ip-address": "",
    "terminal-id": "",
    type: 'ipad',
    port: '',
    'printer-settings': {
      'printer-manufacturer': '',
      'receipt-mode': '',
      'ip-address': '',
      'printer-name': '',
    },
    'payment-settings': {
      'terminal-poiid': '',
      'key-version': '',
      'key-identification': '',
      'key-passphrase': '',
    },
    "is-maintenance-mode": false
  };
  devices: any = [
    {text: 'Counter-Top (iPad)', value: 'ipad'},
    {text: 'Tower (Windows)', value: 'windows'},
  ]
  manufacturers: any = [
    {text: 'SUNMI', value: 'sunmi'},
    {text: 'Epson', value: 'epson'},
  ]
  modes: any = [
    {text: 'SMS', value: 'sms'},
    {text: 'QR', value: 'qr'},
    {text: 'PRINTER', value: 'printer'},

  ]

  terminal: any = [
    {text: 'Intersoft (legacy)', value: 'intersoft'},
    {text: 'A920 (legacy)', value: 'geidea-pax'},
    {text: 'VX690 (legacy)', value: 'geidea-verifone'},
  ]

  terminal1: any = [
    // {text: 'Ingenico (legacy)', value: 'ingenico'},
    {text: 'A920 (legacy)', value: 'geidea-pax'},
    {text: 'VX690 (legacy)', value: 'geidea-verifone'},
    {text: 'Adyen', value: 'adyen'},
    {text: 'Intersoft (legacy)', value: 'intersoft'},
    {text: 'Paymob (legacy)', value: 'paymob'},
    // {text: 'UHIP (universal hardware integration platform)', value: 'uhip'},

  ]
  options: any = [];
  customers: any = []
  confirm1!: Function
  translate!: Function;
  systemErrorNotification!: Function;
  successNotification!: Function;
  POSvalue: Boolean = true

  @Prop() locations!: any;

  @Prop() flagpill: any;

  @Watch("open", {immediate: true, deep: true})
  onOpenChanged(newVal: any) {
    if (!newVal) {
      this.closeMe();
      this.resetModel();
    } else {
      if(this.locations.length > 0) {
        let loc = this.locations.find((loc: any) => Number(loc?.id) === Number(this.model['location-id']));
        this.model['location-id'] = loc['id'];
      }
    }
  }

  @Watch("model", {immediate: true, deep: true})
  checkPOSValue(newVal: any) {
    if (newVal) {

      this.filterCustomer(this.model['customer-id']);

      this.model['printer-settings']['printer-manufacturer'] = 'sunmi';
      this.model['printer-settings']['receipt-mode'] = 'printer';

      const found = this.locations
            .find((loc: any) => Number(loc.id) === Number(newVal['location-id']));

      if (newVal['payment-gateway'] == 'geidea-pax') {
        this.model.port = 6100;
      } 

      if (newVal['payment-gateway'] == 'geidea-verifone') {
        this.model.port = 80;
      } 

      if(found?.attributes.pos === 'foodics-f5' || found?.attributes.pos === 'foodics' || found?.attributes.pos === 'ocost' || found?.attributes.pos === 'sdm' || found?.attributes.pos === 'revel' || found?.attributes.pos === 'posist') {
        this.POSvalue = false;
      } else {
        this.POSvalue = true;
      }
    }
  }
  mounted() {
    this.getCustomers(1);
  }


  async searchCustomer(name: any) {
    this.customers = [];
    this.searching = true
    await Customer.searchInKiosk(name).then((response: any) => {
      this.customers = response?.data?.data;
      this.searching = false
    });

  }

  async searchLocationFunc(name: any) {
    let lang = 'en-us';
    this.locations = [];
    this.loading = true
    await Customer.searchLocInKiosk(name,lang).then((response: any) => {
      this.locations = response?.data?.data;
      this.loading = false
    });

  }

  async filterCustomer(name: any) {
    this.loading = true
    await Customer.getCustomerName(name).then((response: any) => {
      this.customers = response.data.data
      this.loading = false
    });

  }

  async getCustomers(page: 1) {
    this.loading = true
    await Customer.all(page)
      .then((response: any) => {
        this.customers = response.data.data
        this.customerMeta = response.data.meta.pagination
        this.loading = false
      })
  }
  resetModel() {
    this.model = {
      id: "",
      label: "",
      status: "",
      available: false,
      "location-id": "",
      "customer-id": "",
      "payment-gateway": "",
      uuid: "",
      "ip-address": "",
      "terminal-id": "",
      type: 'ipad',
      "is-settings-password-protected": false,
      port: '',
      'printer-settings': {
        'printer-manufacturer': '',
        'receipt-mode': '',
        'ip-address': '',
        'printer-name': '',
      },
      'payment-settings': {
        // 'business-reference-id':'',
        'terminal-poiid': '',
        'key-version': '',
        'key-identification': '',
        'key-passphrase': '',
      },
      'is-maintenance-mode': false
    }
  }


  closeMe() {
    this.open = false;
    this.$emit("close");
  }

  deleteMsgBoxText(e: any) {
    return this.translate(e) + 'You need a kiosk license to add a kiosk device, go to Account Page please click (OK).';
  }

  async submit(e: any) {

    const isValid = await this.$refs.formValidator.validate();
    if (!isValid || this.saving) {
      return;
    }

    /* @ts-ignore */
    this.saving = true;
    try {
      if (this.model.id) {
        let response = await DeviceService.update(this.model.id, this.model);
      } else {
        let response = await DeviceService.create(this.model);
      }
      /* @ts-ignore */
      analytics.track(this.model.id ? 'update_kiosk' : 'create_kiosk', {
        location_id: this.model['location-id'],
        device: this.model['type'] ? this.devices.find((device: any) => device.value === this.model['type'])['text'] : null,
        printer_manufacturer: this.model['printer-settings']['printer-manufacturer'] ? this.manufacturers.find((manufacture: any) => manufacture.value === this.model['printer-settings']['printer-manufacturer'])['text'] : null,
        receipt_mode: this.model['printer-settings']['receipt-mode'] ? this.modes.find((mode: any) => mode.value === this.model['printer-settings']['receipt-mode'])['text'] : null,
        card_payment_terminal: this.model['payment-gateway'] ? (this.model['type'] === 'windows' ? this.terminal1.find((term: any) => term.value === this.model['payment-gateway'])['text'] : this.terminal.find((term: any) => term.value === this.model['payment-gateway'])['text']) : null,
      });
      this.successNotification();
      this.saving = false;
      this.closeMe();
      this.$emit("successfulFormSubmit");
      this.resetModel();
    } catch (error) {
      /* @ts-ignore */
      // this.$emit("modal:openKioskError", true);
      /* @ts-ignore */
     const re = await this.confirm1(this.$bvModal, this.deleteMsgBoxText(error.response.data.error[0].detail))
      if(re) {
        this.$router.push('/account');
      }
      this.saving = false;

    }
  }
}
